/**
 * Les trois compétences de la compréhension de l'écrit, telles que le ministère les écrit dans les libellés
 * des items de 6e (évaluation nationale 2026 : Arachné 4 / 4 / 2, Sommeil 3 / 2 / 4). Une question d'une forme
 * parallèle porte le même libellé que les items de septembre de sa famille : la progression se compare par
 * compétence (et par support), jamais question par question (11/10/2026).
 */
export const COMPETENCES = {
    explicite: 'Retrouver une information explicite plus ou moins aisément repérable',
    inference: 'Mettre en relation des informations et établir des inférences',
    sens_global: 'Rendre compte du sens global et identifier la visée',
};

/** Les deux supports d'un test de compréhension, comme le ministère rend ses scores. */
export const SUPPORTS = {
    litteraire: 'Texte littéraire',
    documentaire: 'Support documentaire',
};
